import { useRequest } from 'hooks/useRequest'
import React, { useEffect, useRef, useState } from 'react'
import Button from 'components/form-elements/buttons/Button'
import images from 'assets/images/images'
import auth from 'utils/Auth'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import CurrencyFormatter from 'utils/CurrencyFormatter'
import LoaderTwo from './LoaderTwo'
import useTranslate from 'hooks/useTranslate'
import {dataLayerPush} from 'utils/Datalayer'

const OrderDetail = () => {
	//const [getAllBasketPayment, setGetAllBasketPayment] = useState([])
	const navigate = useNavigate();
	const [request, loading] = useRequest()
    const {id} = useParams();
    const location = useLocation();
	const [orderDetail, setOrderDetail] = useState([])
	const {t} = useTranslate()
	const purchaseEventSent = useRef(false);

    const headerOptions = {
        RestaurantId : auth?.getUserChoises()?.restaurantId,
        DeliveryType : auth?.getUserChoises()?.deliveryType,
        NeighbourhoodId : auth?.getUserChoises()?.neighbourhoodId,
        RegionId : auth?.getUserChoises()?.regionId,
      }
 
	useEffect(() => {
		// Purchase event'inin sadece bir kez gönderilmesi için kontrol
		purchaseEventSent.current = false;

		request(`/Order/${id}`, {
			method: 'GET',
			headers: headerOptions,
		}).then((res) => {
			if (res?.response?.data?.ok == false) {
				navigate('/hata/500')
			}
			if (res) {
				setOrderDetail(res?.data?.result)
				console.log("res?.data?.result", res?.data?.result);

				// Purchase event'i sadece bir kez gönder (localStorage kontrolü ile)
				if (res?.data?.ok) {
					const orderNumber = res?.data?.result?.orderNumber;
					const purchaseEventKey = `purchase_sent_${orderNumber}`;
					
					// LocalStorage'da bu sipariş için event gönderilmiş mi kontrol et
					const isPurchaseEventSent = localStorage.getItem(purchaseEventKey);
					
					if (!isPurchaseEventSent && !purchaseEventSent.current) {
						purchaseEventSent.current = true;
						dataLayerPush({ ecommerce: null });
						dataLayerPush({
							event:"purchase",
							ecommerce: {
							item_list_name: "Listeleme Sayfası",
							currency: "TRY",
							tax:0,
							shipping:0,
							coupon:"",
							transaction_id: orderNumber,
							value: res?.data?.result?.orderTotal,
							items: res?.data?.result?.orderItems
							?.flatMap((prev) => {
								const category = prev?.categories?.[0]?.value
								const productAttributes = prev?.attributes
								const breadSelection = productAttributes?.find((a) => a?.name?.includes("Ekmek"))?.values?.find((a) => a?.isPreSelected)?.name
								const saladSelection = productAttributes?.find((a) => a?.name?.includes("Salata"))?.values?.find((a) => a?.isPreSelected)?.name
								const promotionSelection = productAttributes?.find((a) => a?.name?.includes("Promosyon"))?.values?.find((a) => a?.isPreSelected)?.name
							const baseItem = {
								item_id: prev?.productId,
								item_name: prev?.productName,
								affilication: "Tavuk Dünyası",
								discount: prev?.discountAmount,
								item_variant:(category?.includes('İçecek')||category?.includes('Tatlı') || category?.includes('Başlangıç') || category?.includes('Salata')) ? 'Ek Ürün' : 'Ana Ürün',
								item_brand: "Tavuk Dünyası",
								item_list_name: "Listeleme Sayfası",
								item_category: prev?.categories?.[0]?.value,
								item_category2: prev?.categories?.[1]?.value ? prev?.categories?.[1]?.value : "",
								item_category3: prev?.categories?.[2]?.value ? prev?.categories?.[2]?.value: "",
								bread_selection: breadSelection || "" , // kullanıcı seçimine göre değişecek
								salad_selection: saladSelection || "" , // kullanıcı seçimine göre değişecek
								promotion_selection: promotionSelection || "" , // kullanıcı seçimine göre değişecek
								price: prev?.price,
								quantity: prev?.quantity
							};
							const attributeItems = prev?.attributes?.map((attr) => ({
								item_id: attr.productAttributeId,
								item_name: `${attr.valueName}`,
								affilication: "Tavuk Dünyası",
								item_brand: "Tavuk Dünyası",
								item_list_name: "Listeleme Sayfası",
								item_category: attr.name,
								item_variant: 'Ek Ürün',
								price: attr.price,
								quantity: prev?.quantity
							})) || [];
							return [baseItem, ...attributeItems];
							})
							?.map((item, i) => ({ ...item, index: i }))
						}
						})
						
						// Purchase event gönderildi, localStorage'a kaydet
						localStorage.setItem(purchaseEventKey, 'true');
					}
				}
			}
		})
	}, [id])


    const myOrders = () => {
		navigate('/siparislerim')
    }

    let searchParams = location.search.split('=')[1];

    useEffect(() => {
		window.scrollTo(0, 0)
	}, [])
	
	return (
		<div className='payment'>
			<LoaderTwo isDataLoading={loading} />
			<div className='payment-left'>
				<div className='payment-left-addressTitle'>
                    {
                        searchParams == "true" ? (
                            <>
                             <img src={images.greenTick} alt="" />
                             <div style={{ color: "#30A46C"}}>{t('orderReceived')}...</div>
                            </>
                        ) :  <div style={{}}>{t('orederDetails')}</div>
                    }
                   
                </div>
				<h1 className='payment-left-addressSubtitle'>{orderDetail?.deliveryType == 2 ? t('cometoMyAddress') : t('comeGetIt')}</h1>
				<h2 className='payment-left-addressTitle'>{t('branch')}: {orderDetail?.restaurant?.name}</h2>
				<div className='payment-left-addressDescription'>{t('branchAddress')}: {orderDetail?.restaurant?.address}</div>

				<div className='payment-left-infoEdit'>
					<div className='payment-left-infoEdit-cont'>
						<div className='payment-left-infoEdit-title'>{t('receiverInfo')}</div>
						<div className='body-s payment-left-infoEdit-desc'>{orderDetail?.userFullName}</div>
					</div>
				</div>

                {
					orderDetail?.userAddress && (
                  <div className='payment-left-infoEdit'>
					<div className='payment-left-infoEdit-cont'>
						<div className='payment-left-infoEdit-title'>{t('address')}</div>
						<div className='body-s payment-left-infoEdit-desc'>{orderDetail?.userAddress?.fullAddress}</div>
					</div>
				</div>
					)
				}
				

				{
					orderDetail?.deliveryType == 2 && <div className='payment-left-choiceComp'>
						<div className='payment-left-choiceComp-title'>{t('deliveryTime')}</div>
						<div>
							<div className='payment-left-choiceComp-container'>
							{
								orderDetail?.futureDeliveryDate ? orderDetail?.futureDeliveryDate.split('T')[0] : "Hemen (45-60 dakika)"  
							}	
							</div>
						</div>
					</div>
				}

				<div className='payment-left-choiceComp'>
					<div className='payment-left-choiceComp-title'>{t('wantPlasticKnives')}</div>
					<div>
						<div className='payment-left-choiceComp-container'>{orderDetail?.wantService ? t('yes') : t('no')}</div>
					</div>
				</div>

				{
					orderDetail?.deliveryType == 2 && <div className='payment-left-choiceComp payment-left-choiceCompCheckbox'>
					<div className='payment-left-choiceComp-title'>{t('deliveryType')}</div>
					<div className='payment-left-choiceComp-container'>{orderDetail?.wantContactlessDelivery ? t('wantContactlessDelivery') : t('notWantContactlessDelivery')}</div>
				</div>
				}

				{/* <ChoiceComp setPaymentChoice={setPaymentChoice} paymentChoice={paymentChoice} title={"Teslimat Zamanı"} description1={"Hemen (~30 dakika)"} description2={"İleri tarihli"} value={{val1: null, val2: "nextDate"}} name = {"futureDeliveryDate"} type={"radio"} dateOpen/> */}
				{/* <ChoiceComp setPaymentChoice={setPaymentChoice} paymentChoice={paymentChoice} title={"Plastik bıçak vs istemiyor musunuz?"} description1={"Evet"} description2={"Hayır"} value={{val1: true, val2: false}} name = "wantService" type={"radio"}/> */}
				{/* <ChoiceComp title={"Teslimat Tipi"} type={"checkbox"} value={false} name={"wantContactlessDelivery"}/> */}
				<div className='payment-left-note'>
					<div className='payment-left-note-title'>{t('orderNote')}</div>
					<div className='payment-left-choiceComp-container'>{orderDetail?.note ? orderDetail?.note : '-'}</div>
				</div>
				<div className='payment-left-order'>
					<div className='payment-left-order-top'>
						<div className='payment-left-order-top-title'>{t('yourOrder')}</div>
					</div>
					<div className='payment-left-order-container'>
						{orderDetail?.orderItems?.map((order, i) => (
							<div key={i} className='payment-left-order-container-card'>
								<div className='cardFlex'>
									<div className='payment-left-order-container-card-left'>
										{"x" + order?.quantity}
										<div className='payment-left-order-container-card-left-text'>
											<div className='header-s text-primary'>{order?.productName}</div>
											<div className='header-m text-orange'>{order?.unitPrice} TL</div>
										</div>
									</div>
									<div className='payment-left-order-container-card-right'>
										<img src={order?.pictureUrl} alt='' />
									</div>
								</div>
								<div className='extraProducts'>
								{order?.attributes?.map((or, i) => (
									<div className='' key={i}>
										{or?.valueName},{' '}
									</div>
								))}
								</div>
								
								{/* {order?.pictureUrl && <div className='addNote'>{images?.addNote}</div>} */}
							</div>
						))}
					</div>
				</div>

				{/* <Drawer open={isOpenDrawer} onClose={() => setIsOpenDrawer(!isOpenDrawer)} direction='right' className='paymentAddBasketDrawer'>
					<PaymentAddBasketDrawer setIsOpenDrawer={setIsOpenDrawer} />
				</Drawer> */}
			</div>
			<div className='payment-right'>
				<div className='payment-right-title'>{t('totalAmount')}</div>
				{orderDetail?.subTotal != orderDetail?.orderTotal &&<div className='payment-right-oldPrice'><CurrencyFormatter locale='tr' currency='TRY' value={orderDetail?.subTotal} /></div>}
				<div className='payment-right-price'><CurrencyFormatter locale='tr' currency='TRY' value={orderDetail?.orderTotal} /></div>
				{/* <div className='payment-right-description'>Minimum sipariş tutarı: 000,00 TL</div> */}
				{/* <div className='payment-right-textCode'>
        <div className="payment-right-textCode-left">İndirim Kodu</div>
        <div className="payment-right-textCode-right">Kullan</div>
       </div> */}
				{/* <ChoiceComp title={"Kampanya"} description1={"Kampanyaya katılmak istemiyorum."} description2={"Kampanya adı 1"} description3={"Kampanya adı 2"} name = "3" type={"radio"}/> */}
				<div className='payment-left-choiceComp'>
					<div className='payment-left-choiceComp-title'>{t('paymentOptions')}</div>
                       <div className='payment-left-choiceComp-container'>{orderDetail?.paymentType?.name}</div>	
				</div>
				<div className='payment-right-complete'>
					<Button onClick={myOrders} className={'claretredRoundedBtn'} icon={''} text={t('myorders')} />
				</div>
			</div>
		</div>
	)
}

export default OrderDetail
